import { MESSAGE } from "../Components/Config"

export const useMovil = (categoria) => {
  const channel = sessionStorage.getItem('channel')
  const movil = channel !== 'ONLINE'
  // const hasDownload = true
  const message = movil ? MESSAGE[categoria] : ''
  return { movil, channel, hasDownload: !movil, message }
}